import React, { useContext, ReactNode, PropsWithChildren, useEffect } from "react";
import MultiSelectFormWraper from "./MultiSelectFormWraper";
import { MultiSelectFormContext } from "~/contexts/MultiSelectForm";

import "tippy.js/dist/tippy.css";
import Footer from "~/components/Footer";
import Timeline from "./CategoryForm/TimeLine";

type MultiStepFormProps = {
    goToStep: (step: number) => void;
    prevStep: () => void;
    nextStep: () => void;
    currentStep: number;
    children?: ReactNode;
    utmSource: string;
};

const MultiStepForm = ({ children, goToStep, nextStep, currentStep, prevStep, utmSource }: MultiStepFormProps) => {
    const { setTotalSteps, updateStepStorage } = useContext(MultiSelectFormContext);
    const totalSteps = React.Children.count(children);

    const CurrentStepComponent = React.cloneElement(
        children[currentStep - 1] as React.ReactElement<PropsWithChildren<MultiStepFormProps>>,
        {
            goToStep,
            nextStep,
            prevStep,
            currentStep,
            utmSource,
        }
    );

    useEffect(() => {
        updateStepStorage("totalSteps", totalSteps);
        setTotalSteps(totalSteps);
    }, []);

    const steps = ["Segmento", "Data e Local", "Revisão", currentStep === 4 ? "Publicado" : "Publicar"];

    return (
        <>
            {/* <ProgressBar currentStep={currentStep} totalSteps={totalSteps} /> */}
            <Timeline currentStep={currentStep} steps={steps} />
            <MultiSelectFormWraper>{CurrentStepComponent}</MultiSelectFormWraper>
            <Footer />
        </>
    );
};

export default MultiStepForm;
